module.exports = __webpack_public_path__ + "static/img/1-1.f3e8b23.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/3/1-1.png
// module id = d7db
// module chunks = 0